import type { IOfficeFileLinkHandlingInfo, IOfficeLinkInfo } from 'flora-types';
import { GetOfficeFileLinkHandlingInfo } from './GetOfficeFileLinkHandlingInfo';
import { logUsage } from 'owa-analytics';
import type { MailboxInfo } from 'owa-client-types';

async function GetOfficeLinkInfo(
    url: string,
    mailboxInfo: MailboxInfo
): Promise<IOfficeLinkInfo | undefined> {
    const officeFileLinkHandlingInfo: IOfficeFileLinkHandlingInfo | undefined =
        await GetOfficeFileLinkHandlingInfo(mailboxInfo);
    if (officeFileLinkHandlingInfo) {
        const officeLinkInfo: IOfficeLinkInfo =
            await officeFileLinkHandlingInfo.GetLinkOpenOptionInfo(
                url,
                'monarch' // appId
            );

        if (officeLinkInfo) {
            const isEligible: boolean = await officeLinkInfo.IsEligible();

            logUsage('GetOfficeLinkInfo', mailboxInfo, { isEligible });

            if (isEligible) {
                return officeLinkInfo;
            }
        }
    }

    return undefined;
}

export async function GetUrlToOpenUsingDefault(
    url: string,
    mailboxInfo: MailboxInfo
): Promise<string | undefined> {
    const officeLinkInfo: IOfficeLinkInfo | undefined = await GetOfficeLinkInfo(url, mailboxInfo);
    if (officeLinkInfo) {
        const urlToOpenUsingDefault: string = await officeLinkInfo.UrlToOpenUsingDefault();
        const clickCorrelationId: string = await officeLinkInfo.LatestClickCorrelationId();

        logUsage('GetUrlToOpenUsingDefault', mailboxInfo, { clickCorrelationId });

        return urlToOpenUsingDefault;
    }

    return undefined;
}
